import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

function SsoCallback({ onLogin }) {
  const navigate = useNavigate();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const params = new URLSearchParams(window.location.hash.replace(/^#/, ''));
    const token = params.get('token');
    window.history.replaceState(null, '', window.location.pathname);

    if (!token) {
      navigate('/login');
      return;
    }

    axios.post('/api/auth/sso-login', { token })
      .then(res => {
        localStorage.setItem('token', res.data.token);
        localStorage.setItem('user', JSON.stringify(res.data.user));
        axios.defaults.headers.common['Authorization'] = `Bearer ${res.data.token}`;
        onLogin(res.data.user);
        navigate('/');
      })
      .catch(() => navigate('/login'));
  }, [navigate, onLogin]);

  return null;
}

export default SsoCallback;
